// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"dataProductItemV2_carouselContainer__8Mrq9","cardBody":"dataProductItemV2_cardBody__3kTUH","subtitle":"dataProductItemV2_subtitle__a-X79"};